

















































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
const roleManager = namespace("roleManager");
import add from "./add.vue";
import resource from "./resource.vue";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl
} from "@root/lib/decorator";
@Component({
  components: { add, resource }
})
@SearchbarControl()
@pagination("getDataList", { pageSize: 10, currentPage: 1 })
@loading(true)
export default class roleManagerPage extends Vue {
  @Prop({
    default: () => {
      return {
        title: "角色管理",
        isSearch: true,
        searchOptions: ["roleName"],
        isCreate: true
      };
    }
  })
  options: any;
  form: any = {
    roleName: ""
  };
  loading: boolean = false;
  total: number = 0;
  @roleManager.Action getRoleList;
  @roleManager.State dataList;
  @roleManager.Action deleteRole;
  editData: any = null;
  isEdit: boolean = false;
  isOaCooperation: any = '';
  mounted() {
    this.isOaCooperation = localStorage.getItem("isOaCooperation");
    this.getDataList();
  }
  async getDataList() {
    const { pageSize, currentPage: pageNum }: any = this;
    try {
      this.loading = true;
      let { total } = await this.getRoleList({
        pageInput: {
          pageSize,
          pageNum
        },
        roleName: this.form.roleName
      });
      this.total = total;
    } catch {
      //
    } finally {
      this.loading = false;
    }
  }
  async handleDelete(data) {
    await this.$confirm("删除角色则该角色下的权限将被收回，你确定要删除吗？");
    await this.deleteRole({
      roleCode: data.roleCode
    });
    this.$message({ type: "success", message: "删除成功" });
    (this as any).currentPage = 1;
    this.getDataList();
  }
  handleAdd() {
    this.editData = null;
    this.isEdit = false;
    (this as any).$refs.addRole.dialogVisible = true;
  }
  handleEdit(data) {
    this.editData = data;
    this.isEdit = true;
    (this as any).$refs.addRole.dialogVisible = true;
  }
  handleResource(data) {
    this.editData = data;
    this.isEdit = true;
    (this as any).$refs.resource.dialogVisible = true;
  }
  refresh(flag) {
    //1 是编辑 0 是新增
    if (flag === 1) {
      this.getDataList();
    } else {
      (this as any).currentPage = 1;
      this.getDataList();
    }
  }
}
